<template>
    <div class="ma-4">
        <ClientNav/>
        <v-row dense>
            <v-col cols="12">
                <v-card>
                    <v-card-title style="background-color: #2b3990">
                        <span class="headline white--text">{{ titleForm }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="3">
                                    <v-menu
                                        ref="menu"
                                        v-model="menu"
                                        :close-on-content-click="false"
                                        :return-value.sync="date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="drillDate"
                                                label="Drill Date"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                clearable
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="drillDate"
                                            no-title
                                            scrollable
                                        >
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="menu = false"
                                            >
                                                Cancel
                                            </v-btn>
                                            <v-btn
                                                text
                                                color="primary"
                                                @click="$refs.menu.save(date)"
                                            >
                                                OK
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" sm="12" md="3">
                                    <v-menu
                                        ref="startTime"
                                        v-model="startTimeMenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        :return-value.sync="date"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="startTime"
                                                label="Drill Start Time"
                                                prepend-icon="schedule"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-time-picker
                                            v-if="startTimeMenu"
                                            v-model="startTime"
                                            full-width
                                            @click:minute="$refs.startTime.save(startTime)"
                                        ></v-time-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" sm="12" md="3">
                                    <v-select
                                        :items="times"
                                        label="Duration of the Drill (minutes)"
                                        v-model="duration"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" sm="12" md="3">
                                    <v-text-field
                                        label="Number of People Participating in the Drill"
                                        v-model="numberOfPeople"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" v-if="createFireDrill">
                                    <v-select
                                        filled
                                        :items="clients"
                                        item-text="Name"
                                        item-value="_id"
                                        label="Clients that Attended"
                                        multiple
                                        v-model="newClients"
                                    ></v-select>
                                </v-col>
                            </v-row>
                            <v-col cols="12" sm="12" md="6">
                                <h3>All Clients Evacuated in 90 Seconds?</h3>
                                <v-switch
                                    v-model="evacuated"
                                    label="Yes"
                                    value="Yes"
                                ></v-switch>
                                <v-switch
                                    v-model="evacuated"
                                    label="No"
                                    value="No"
                                ></v-switch>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                v-if="evacuated === 'No'"
                            >
                                <v-textarea
                                    v-model="evacuatedExplain"
                                    outlined
                                    label="Please Explain"
                                ></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <h3>
                                    Client and Staff Meet at Designated Meeting
                                    Location?
                                </h3>
                                <v-switch
                                    v-model="location"
                                    label="Yes"
                                    value="Yes"
                                ></v-switch>
                                <v-switch
                                    v-model="location"
                                    label="No"
                                    value="No"
                                ></v-switch>
                            </v-col>
                            <v-col cols="12" sm="12" md="6" v-if="location === 'No'">
                                <v-textarea
                                    v-model="locationExplain"
                                    outlined
                                    label="Please Explain"
                                ></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <h3>
                                    Staff Closed Doors in Area of (Hypothetical) Fire?
                                </h3>
                                <v-switch
                                    v-model="closedDoors"
                                    label="Yes"
                                    value="Yes"
                                ></v-switch>
                                <v-switch
                                    v-model="closedDoors"
                                    label="No"
                                    value="No"
                                ></v-switch>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                v-if="closedDoors === 'No'"
                            >
                                <v-textarea
                                    v-model="closedDoorsExplain"
                                    outlined
                                    label="Please Explain"
                                ></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <h3>Obstacles Were Faced During the Drill?</h3>
                                <v-switch
                                    v-model="obstacles"
                                    label="Yes"
                                    value="Yes"
                                ></v-switch>
                                <v-switch
                                    v-model="obstacles"
                                    label="No"
                                    value="No"
                                ></v-switch>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                v-if="obstacles === 'Yes'"
                            >
                                <v-textarea
                                    v-model="obstaclesExplain"
                                    outlined
                                    label="Please Explain"
                                ></v-textarea>
                            </v-col>

                            <v-col cols="12" sm="12" md="6">
                                <h3>
                                    Staff Completed Head Count at Designated Meeting
                                    Location?
                                </h3>
                                <v-switch
                                    v-model="headCount"
                                    label="Yes"
                                    value="Yes"
                                ></v-switch>
                                <v-switch
                                    v-model="headCount"
                                    label="No"
                                    value="No"
                                ></v-switch>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                v-if="headCount === 'No'"
                            >
                                <v-textarea
                                    v-model="headCountExplain"
                                    outlined
                                    label="Please Explain"
                                ></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <h3>All Staff and Clients Participated?</h3>
                                <v-switch
                                    v-model="allParticipation"
                                    label="Yes"
                                    value="Yes"
                                ></v-switch>
                                <v-switch
                                    v-model="allParticipation"
                                    label="No"
                                    value="No"
                                ></v-switch>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                v-if="allParticipation === 'No'"
                            >
                                <v-textarea
                                    v-model="allParticipationExplain"
                                    outlined
                                    label="Please Explain"
                                ></v-textarea>
                            </v-col>

                            <v-col cols="12" sm="12" md="6">
                                <h3>Fire Extinguishers Tagged and Current?</h3>
                                <v-switch
                                    v-model="taggedCurrent"
                                    label="Yes"
                                    value="Yes"
                                ></v-switch>
                                <v-switch
                                    v-model="taggedCurrent"
                                    label="No"
                                    value="No"
                                ></v-switch>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                v-if="taggedCurrent === 'No'"
                            >
                                <v-textarea
                                    v-model="taggedCurrentExplain"
                                    outlined
                                    label="Please Explain"
                                ></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <h3>All Smoke Detectors in the House are Working</h3>
                                <v-switch
                                    v-model="detectorsWorking"
                                    label="Yes"
                                    value="Yes"
                                ></v-switch>
                                <v-switch
                                    v-model="detectorsWorking"
                                    label="No"
                                    value="No"
                                ></v-switch>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                v-if="detectorsWorking === 'No'"
                            >
                                <v-textarea
                                    v-model="detectorsWorkingExplain"
                                    outlined
                                    label="Please Explain"
                                ></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <h3>Smoke Detectors are on Each Level of the Home</h3>
                                <v-switch
                                    v-model="eachLevel"
                                    label="Yes"
                                    value="Yes"
                                ></v-switch>
                                <v-switch
                                    v-model="eachLevel"
                                    label="No"
                                    value="No"
                                ></v-switch>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                v-if="eachLevel === 'No'"
                            >
                                <v-textarea
                                    v-model="eachLevelExplain"
                                    outlined
                                    label="Please Explain"
                                ></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <h3>
                                    All Carbon Monoxide Detectors in Home are Working?
                                </h3>
                                <v-switch
                                    v-model="carbonMonoxide"
                                    label="Yes"
                                    value="Yes"
                                ></v-switch>
                                <v-switch
                                    v-model="carbonMonoxide"
                                    label="No"
                                    value="No"
                                ></v-switch>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                v-if="carbonMonoxide === 'No'"
                            >
                                <v-textarea
                                    v-model="carbonMonoxideExplain"
                                    outlined
                                    label="Please Explain"
                                ></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <h3>
                                    Carbon Monoxide Detector Found on Each Level of Home
                                </h3>
                                <v-switch
                                    v-model="carbonEachLevel"
                                    label="Yes"
                                    value="Yes"
                                ></v-switch>
                                <v-switch
                                    v-model="carbonEachLevel"
                                    label="No"
                                    value="No"
                                ></v-switch>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="12"
                                md="6"
                                v-if="carbonEachLevel === 'No'"
                            >
                                <v-textarea
                                    v-model="carbonEachLevelExplain"
                                    outlined
                                    label="Please Explain"
                                ></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="12">
                                <v-textarea
                                    v-model="comments"
                                    outlined
                                    label="Additional Comments"
                                ></v-textarea>
                            </v-col>

                            <v-col cols="12">
                                <v-file-input
                                    v-model="newDocument"
                                    class="pa-2"
                                    label="Select documents to upload"
                                    show-size
                                    filled
                                    multiple
                                    prepend-icon="mdi-camera"
                                    accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                    @change="fileSelected"
                                >
                                    <template #selection="{ text, index }">
                                        <v-chip
                                            small
                                            label
                                            close
                                            color="primary"
                                            @click:close="deleteChip(index)"
                                        >{{ text }}
                                        </v-chip
                                        >
                                    </template>
                                </v-file-input>
                            </v-col>

                            <v-col
                                cols="12"
                                sm="12"
                                v-for="doc in newDocument"
                                :key="doc.awsLink"
                            >
                                <div v-if="doc.ext !== 'pdf'">
                                    <v-img
                                        max-height="480"
                                        max-width="550"
                                        :src="doc.awsLink"
                                    ></v-img>
                                </div>
                                <div v-if="doc.ext === 'pdf'">
                                    <LoadPdf
                                        :pdfFile="doc.awsLink"
                                        :pdfName="doc.name"
                                    />
                                </div>
                            </v-col>

                            <v-col cols="12" sm="12" md="6">
                                <v-checkbox
                                    v-model="signed"
                                    label="Staff Signature"
                                    outlined
                                    @click="addStaffSig()"
                                ></v-checkbox>
                                <v-text-field
                                    label="Signed By"
                                    v-model="newStaffSignature"
                                ></v-text-field>
                            </v-col>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            fab
                            small
                            @click="showPrint()"
                            class="mr-8 mb-2 white--text"
                            color="#2b6993"
                            elevation="4"
                            v-if="!createFireDrill"
                        >
                            <v-icon>print</v-icon>
                        </v-btn>
                        <v-btn
                            class="white--text"
                            color="#259647"
                            @click="addFireDrill()"
                            v-if="createFireDrill && !isAuditorRole"
                        >Save
                        </v-btn>
                        <v-btn
                            class="white--text"
                            color="#259647"
                            @click="updateFireDrill()"
                            v-if="editFireDrill && !isAuditorRole"
                        >Update
                        </v-btn>
                        <v-btn color="blue darken-1" text @click="close" :disabled="isSavingImage">Cancel</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
        <Foot/>
    </div>
</template>

<script>
import axios from "axios";
import Foot from "@/components/Footer";
import ClientNav from "@/components/ClientNav.vue";
import moment from "moment";
import LoadPdf from "@/components/LoadPDF.vue";
import renameFileHelper from "@/mixins/renameFileHelper";
import {ROLES} from "@/enums/RolesEnum";
import {displayError, displaySuccess, displayInfo} from "@/service/notification-message.service";
import PrintUtil from "../../../../utils/print-util";

const url = require("../../../client_config/config").url;

export default {
    mixins: [renameFileHelper],
    components: {
        Foot,
        ClientNav,
        LoadPdf,
    },
    data: function () {
        return {
            date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10),
            menu: false,
            menu2: false,
            startTimeMenu: false,
            msg: false,
            signed: false,
            search: "",
            text: "",
            fireDrills: [],
            fireDrill: {},
            tempData: [],
            codes: [],
            clients: [],
            newClients: [],
            clientID: this.$route.params.clientID,
            role: localStorage.getItem("userRole"),
            display: false,
            nav: true,
            newStaffSignature: "",
            staff: localStorage.getItem("Name"),
            token: localStorage.getItem('token'),
            titleForm: "New Fire Drill",
            fireDrillID: "",
            fireDrillId: this.$route.params.id,
            drillDate: moment(new Date()).format("YYYY-MM-DD"),
            evacuated: "",
            evacuatedExplain: "",
            location: "",
            locationExplain: "",
            closedDoors: "",
            closedDoorsExplain: "",
            obstacles: "",
            obstaclesExplain: "",
            headCount: "",
            headCountExplain: "",
            allParticipation: "",
            allParticipationExplain: "",
            startTime: "",
            duration: "",
            numberOfPeople: "",
            taggedCurrent: "",
            taggedCurrentExplain: "",
            detectorsWorking: "",
            detectorsWorkingExplain: "",
            eachLevel: "",
            eachLevelExplain: "",
            carbonMonoxide: "",
            carbonMonoxideExplain: "",
            carbonEachLevel: "",
            carbonEachLevelExplain: "",
            comments: "",
            newDocument: [],
            uploadFile: "",
            fireDrillForm: "",
            editedIndex: -1,
            editedItem: {
                DrillDate: "",
                Evacuated: "",
                EvacuatedExplain: "",
                Location: "",
                LocationExplain: "",
                ClosedDoors: "",
                ClosedDoorsExplain: "",
                Obstacles: "",
                ObstaclesExplain: "",
                HeadCount: "",
                HeadCountExplain: "",
                AllParticipation: "",
                AllParticipationExplain: "",
                StartTime: "",
                Duration: "",
                NumberOfPeople: "",
                TaggedCurrent: "",
                TaggedCurrentExplain: "",
                DetectorsWorking: "",
                DetectorsWorkingExplain: "",
                EachLevel: "",
                EachLevelExplain: "",
                CarbonMonoxide: "",
                CarbonMonoxideExplain: "",
                CarbonEachLevel: "",
                CarbonEachLevelExplain: "",
                Comments: "",
                StaffSignature: "",
                FireDrillForm: "",
            },
            defaultItem: {
                DrillDate: "",
                Evacuated: "",
                EvacuatedExplain: "",
                Location: "",
                LocationExplain: "",
                ClosedDoors: "",
                ClosedDoorsExplain: "",
                Obstacles: "",
                ObstaclesExplain: "",
                HeadCount: "",
                HeadCountExplain: "",
                AllParticipation: "",
                AllParticipationExplain: "",
                StartTime: "",
                Duration: "",
                NumberOfPeople: "",
                TaggedCurrent: "",
                TaggedCurrentExplain: "",
                DetectorsWorking: "",
                DetectorsWorkingExplain: "",
                EachLevel: "",
                EachLevelExplain: "",
                CarbonMonoxide: "",
                CarbonMonoxideExplain: "",
                CarbonEachLevel: "",
                CarbonEachLevelExplain: "",
                Comments: "",
                StaffSignature: "",
                FireDrillForm: "",
            },
            isLoading: false,
            times: this.getDurations(),
            userState: localStorage.getItem("userState"),
            removedDocuments: [],
            documents: [],
            createFireDrill: false,
            editFireDrill: false,
            isSavingImage: false
        };
    },

    computed: {
        clientName() {
            // `this` points to the component instance
            return this.$store.state.clients.client.Name;
        },
        isAuditorRole() {
            return localStorage.getItem("userRole") === 'Auditor'
        }
    },

    watch: {},

    created() {
        this.createFireDrill = this.$route.query.createFireDrill === "true";
        this.editFireDrill = this.$route.query.updateFireDrill === "true";
        this.getFireDrills();
        this.checkRole();
        this.getClients();
    },

    mounted() {
        if (this.editFireDrill) {
            this.getFireDrill();
        }

        window.addEventListener('keydown', async (event) => {
            const downloadUrl = await this.generateDownloadUrl();
            PrintUtil.handleKeydown(event, downloadUrl, this.fireDrillId, this.token, 'FireDrill');
        });
    },

    beforeDestroy() {
        window.removeEventListener('keydown', (event) => {
            PrintUtil.handleKeydown(event, this.downloadUrl, this.fireDrillId, this.token, 'FireDrill');
        });
    },

    methods: {
        initialize() {
            this.fireDrills = [];
        },

        getDurations() {
            let times = [];
            for (let minutes = 1; minutes <= 10; minutes++) {
                for (let seconds = 0; seconds < 60; seconds += 30) {
                    if (minutes === 10 && seconds === 30) {
                        continue;
                    }
                    const time = `${minutes.toString().padStart(2, "0")}:${seconds
                        .toString()
                        .padStart(2, "0")}`;
                    times.push(time);
                }
            }
            return times;
        },

        viewFireDrill(item) {
            this.dialog = true;
            this.newFireDrill = false;
            this.editFireDrill = true;
            this.drillDate = moment(item.Date).format("YYYY-MM-DD");
            this.evacuated = item.Evacuated;
            this.evacuatedExplain = item.EvacuatedExplain;
            this.location = item.Location;
            this.locationExplain = item.LocationExplain;
            this.closedDoors = item.ClosedDoors;
            this.closedDoorsExplain = item.ClosedDoorsExplain;
            this.obstacles = item.Obstacles;
            this.obstaclesExplain = item.ObstaclesExplain;
            this.headCount = item.HeadCount;
            this.headCountExplain = item.HeadCountExplain;
            this.allParticipation = item.AllParticipation;
            this.allParticipationExplain = item.AllParticipationExplain;
            this.startTime = item.StartTime;
            this.duration = item.Duration;
            this.numberOfPeople = item.NumberOfPeople;
            this.taggedCurrent = item.TaggedCurrent;
            this.taggedCurrentExplain = item.TaggedCurrentExplain;
            this.detectorsWorking = item.DetectorsWorking;
            this.detectorsWorkingExplain = item.DetectorsWorkingExplain;
            this.eachLevel = item.EachLevel;
            this.eachLevelExplain = item.EachLevelExplain;
            this.carbonMonoxide = item.CarbonMonoxide;
            this.carbonMonoxideExplain = item.CarbonMonoxideExplain;
            this.carbonEachLevel = item.CarbonEachLevel;
            this.carbonEachLevelExplain = item.CarbonEachLevelExplain;
            this.comments = item.Comments;
            this.newStaffSignature = item.StaffSignature;
            this.signed = !!item.StaffSignature;
            this.fireDrillForm = item.FireDrillForm;

            if (item.documents.length > 0) {
                const tempData = [];
                for (let i = 0; i < item.documents.length; i++) {
                    let fileExt = item.documents[i].AWSLink.split(".").pop();
                    tempData.push({
                        name: item.documents[i].Name,
                        id: item.documents[i]._id,
                        awsLink: item.documents[i].AWSLink,
                        ext: fileExt,
                    });
                }
                this.newDocument = tempData;
            }
        },

        close() {
            this.$router.go(-1);
            this.clearFields();
        },

        updateFireDrill() {
            let req_body = {
                Date: this.drillDate,
                Evacuated: this.evacuated,
                EvacuatedExplain: this.evacuatedExplain,
                Location: this.location,
                LocationExplain: this.locationExplain,
                ClosedDoors: this.closedDoors,
                ClosedDoorsExplain: this.closedDoorsExplain,
                Obstacles: this.obstacles,
                ObstaclesExplain: this.obstaclesExplain,
                HeadCount: this.headCount,
                HeadCountExplain: this.headCountExplain,
                AllParticipation: this.allParticipation,
                AllParticipationExplain: this.allParticipationExplain,
                StartTime: this.startTime,
                Duration: this.duration,
                NumberOfPeople: this.numberOfPeople,
                TaggedCurrent: this.taggedCurrent,
                TaggedCurrentExplain: this.taggedCurrentExplain,
                DetectorsWorking: this.detectorsWorking,
                DetectorsWorkingExplain: this.detectorsWorkingExplain,
                EachLevel: this.eachLevel,
                EachLevelExplain: this.eachLevelExplain,
                CarbonMonoxide: this.carbonMonoxide,
                CarbonMonoxideExplain: this.carbonMonoxideExplain,
                CarbonEachLevel: this.carbonEachLevel,
                CarbonEachLevelExplain: this.carbonEachLevelExplain,
                Comments: this.comments,
                StaffSignature: this.newStaffSignature,
                FireDrillForm: this.FireDrillForm,
            };

            let fireDrillIndex = this.fireDrills.findIndex((drill) => drill._id === this.fireDrillId);

            this.fireDrills[fireDrillIndex].Date = this.drillDate;
            this.fireDrills[fireDrillIndex].Evacuated = this.evacuated;
            this.fireDrills[fireDrillIndex].EvacuatedExplain = this.evacuatedExplain;
            this.fireDrills[fireDrillIndex].Location = this.location;
            this.fireDrills[fireDrillIndex].LocationExplain = this.locationExplain;
            this.fireDrills[fireDrillIndex].ClosedDoors = this.closedDoors;
            this.fireDrills[fireDrillIndex].ClosedDoorsExplain = this.closedDoorsExplain;
            this.fireDrills[fireDrillIndex].Obstacles = this.obstacles;
            this.fireDrills[fireDrillIndex].ObstaclesExplain = this.obstaclesExplain;
            this.fireDrills[fireDrillIndex].HeadCount = this.headCount;
            this.fireDrills[fireDrillIndex].HeadCountExplain = this.headCountExplain;
            this.fireDrills[fireDrillIndex].AllParticipation = this.allParticipation;
            this.fireDrills[fireDrillIndex].AllParticipationExplain = this.allParticipationExplain;
            this.fireDrills[fireDrillIndex].StartTime = this.startTime;
            this.fireDrills[fireDrillIndex].Duration = this.duration;
            this.fireDrills[fireDrillIndex].NumberOfPeople = this.numberOfPeople;
            this.fireDrills[fireDrillIndex].TaggedCurrent = this.taggedCurrent;
            this.fireDrills[fireDrillIndex].TaggedCurrentExplain = this.taggedCurrentExplain;
            this.fireDrills[fireDrillIndex].DetectorsWorking = this.detectorsWorking;
            this.fireDrills[fireDrillIndex].DetectorsWorkingExplain = this.detectorsWorkingExplain;
            this.fireDrills[fireDrillIndex].EachLevel = this.eachLevel;
            this.fireDrills[fireDrillIndex].EachLevelExplain = this.eachLevelExplain;
            this.fireDrills[fireDrillIndex].CarbonMonoxide = this.carbonMonoxide;
            this.fireDrills[fireDrillIndex].CarbonMonoxideExplain = this.carbonMonoxideExplain;
            this.fireDrills[fireDrillIndex].CarbonEachLevel = this.carbonEachLevel;
            this.fireDrills[fireDrillIndex].CarbonEachLevelExplain = this.carbonEachLevelExplain;
            this.fireDrills[fireDrillIndex].Comments = this.comments;
            this.fireDrills[fireDrillIndex].StaffSignature = this.newStaffSignature;
            this.fireDrills[fireDrillIndex].FireDrillForm = this.FireDrillForm;

            axios
                .put(`${url}/fireDrill/${this.fireDrillId}`, req_body)
                .then((response) => {
                    if (response.status === 400) {
                        response.json().then(function (data) {
                            alert(data.msg);
                        });
                    }
                    this.msg = true;
                    this.text = "The fire drill has been updated successfully.";
                    if (this.uploadFile !== null && this.uploadFile !== undefined) {
                        this.saveFile();
                        if (this.removedDocuments.length > 0) {
                            this.deleteImages();
                        }
                    }

                });
            this.close();
        },

        getFireDrills: function () {
            if (this.isLoading === true) return;

            this.isLoading = true;
            axios
                .get(`${url}/fireDrill/`,
                    {
                        params: {
                            clientID: this.clientID
                        },
                    })
                .then((res) => {
                    this.fireDrills = res.data.fireDrills;
                })
                .finally(() => (this.isLoading = false));
        },

        getFireDrill() {
            this.isLoading = true;
            axios.get(`${url}/fireDrill/${this.fireDrillId}`).then((response) => {

                this.fireDrill = response.data.fireDrill;
                this.viewFireDrill(this.fireDrill);
                this.isLoading = false;
            });
        },

        clearFields() {
            this.drillDate = "";
            this.evacuated = "";
            this.evacuatedExplain = "";
            this.location = "";
            this.locationExplain = "";
            this.closedDoors = "";
            this.closedDoorsExplain = "";
            this.obstacles = "";
            this.obstaclesExplain = "";
            this.headCount = "";
            this.headCountExplain = "";
            this.allParticipation = "";
            this.allParticipationExplain = "";
            this.startTime = "";
            this.duration = "";
            this.numberOfPeople = "";
            this.taggedCurrent = "";
            this.taggedCurrentExplain = "";
            this.detectorsWorking = "";
            this.detectorsWorkingExplain = "";
            this.eachLevel = "";
            this.eachLevelExplain = "";
            this.carbonMonoxide = "";
            this.carbonMonoxideExplain = "";
            this.carbonEachLevel = "";
            this.carbonEachLevelExplain = "";
            this.comments = "";
            this.newStaffSignature = "";
            this.fireDrillForm = "";
            this.newStaff = "";
            (this.newDocument = []), (this.signed = false);
        },

        checkRole() {
            if (
                this.role == "SuperAdministrator" ||
                this.role == "Administration" ||
                this.role == "Program Manager" ||
                this.role == "House Manager" ||
                this.role == "Assistant Manager" ||
                this.role == "Shift Lead" ||
                this.role == "Program Coordinator" ||
                this.role == "Client Services Manager"
            ) {
                this.display = true;
                this.nav = false;
            }
        },

        getClients() {
            let client_url = `${url}/clients`;

            if (this.$store.state.users.userRole !== ROLES.SUPER_ADMINISTRATOR) {
                client_url += `/state/${this.userState}`;
            }
            axios.get(client_url).then((res) => {
                this.clients = res.data.clients;
            });
        },

        async addFireDrill() {
            const baseReqBody = {
                Date: this.drillDate,
                Evacuated: this.evacuated,
                EvacuatedExplain: this.evacuatedExplain,
                Location: this.location,
                LocationExplain: this.locationExplain,
                ClosedDoors: this.closedDoors,
                ClosedDoorsExplain: this.closedDoorsExplain,
                Obstacles: this.obstacles,
                ObstaclesExplain: this.obstaclesExplain,
                HeadCount: this.headCount,
                HeadCountExplain: this.headCountExplain,
                AllParticipation: this.allParticipation,
                AllParticipationExplain: this.allParticipationExplain,
                StartTime: this.startTime,
                Duration: this.duration,
                NumberOfPeople: this.numberOfPeople,
                TaggedCurrent: this.taggedCurrent,
                TaggedCurrentExplain: this.taggedCurrentExplain,
                DetectorsWorking: this.detectorsWorking,
                DetectorsWorkingExplain: this.detectorsWorkingExplain,
                EachLevel: this.eachLevel,
                EachLevelExplain: this.eachLevelExplain,
                CarbonMonoxide: this.carbonMonoxide,
                CarbonMonoxideExplain: this.carbonMonoxideExplain,
                CarbonEachLevel: this.carbonEachLevel,
                CarbonEachLevelExplain: this.carbonEachLevelExplain,
                Comments: this.comments,
                StaffSignature: this.newStaffSignature,
                FireDrillForm: this.fireDrillForm
            };

            for (let i = 0; i < this.newClients.length; i++) {
                let req_body = {...baseReqBody, ClientID: this.newClients[i]};

                try {
                    const response = await axios.post(`${url}/fireDrill`, req_body);

                    if (response.status !== 200) {
                        displayError("An error occurred while saving the fire drill. Please try again.");
                        continue;
                    }

                    if (this.uploadFile) {
                        this.isSavingImage = true;
                        this.fireDrillId = response.data._id;
                        await this.saveFile();
                        displayInfo("Please wait while uploading the files.");
                        this.isSavingImage = false;
                    }

                    displaySuccess("The fire drill info has been sent to selected clients.");
                    this.getFireDrills();
                } catch (error) {
                    console.error("Error during fire drill operation:", error);
                    displayError("An unexpected error occurred. Please try again.");
                } finally {
                    this.close();
                }
            }
        },

        addStaffSig() {
            if (this.newStaffSignature === "") {
                this.newStaffSignature = this.staff + " - " + new Date();
            } else {
                this.newStaffSignature = "";
            }
        },

        async fileSelected(e) {
            this.uploadFile = await this.renameFileHelper(
                e,
                this.clientName,
                "FireDrill"
            );
        },

        saveFile() {
            this.message = "";
            for (let i = 0; i < this.uploadFile.length; i++) {
                this.uploadFiles(this.uploadFile[i]);
            }
        },

        uploadFiles(file) {
            const formData = new FormData();
            formData.append("fireDrill", file);
            var ct = {headers: {"content-type": "multipart/form-data"}};
            axios
                .post(
                    `${url}/fireDrill/fileuploader/${this.fireDrillId}/${this.clientID}`,
                    formData,
                    ct
                )
                .then((res) => {
                    let fireDrillIndex = this.fireDrills.findIndex((drill) => drill._id === this.fireDrillId);
                    this.fireDrills[fireDrillIndex].documents.push(res.data.document);
                })
                .catch((err) => {
                    console.log(err);
                });
        },

        deleteChip(index) {
            this.removedDocuments.push(this.newDocument[index]);
            this.newDocument.splice(index, 1);
        },

        deleteImages() {
            let fireDrillIndex = this.fireDrills.findIndex((drill) => drill._id === this.fireDrillId);
            this.removedDocuments.forEach(document => {
                let documentIndex = this.fireDrills[fireDrillIndex].documents.findIndex((doc) => doc._id === document.id);
                axios.delete(`${url}/documents/${document.id}`)
                    .then(res => {
                        if (res.status === 204) {
                            console.log(document.id + ' has been deleted.');
                        }
                        this.fireDrills[fireDrillIndex].documents.splice(documentIndex, 1);
                    })
                    .catch(err => {
                        console.log(err);
                    });
            });
        },

        async generateDownloadUrl() {
            return `${url}/fireDrill/print-pdf?id=${this.fireDrillId}`;
        },

        async showPrint() {
            const downloadUrl = await this.generateDownloadUrl();
            PrintUtil.showPrintOption(downloadUrl, this.fireDrillId, this.token, 'FireDrill');
        },
    }
    ,
}
;
</script>
